module.exports = __webpack_public_path__ + "static/stamp-fucking-awesome-botto-a548ac408e50feb415d90b7f8eda3315.svg";